var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstitutionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 23.5,
    fill: "#B4E3E1",
    stroke: "#E7F6F5",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 24V32M24.5 24V32M29.5 24V32M34 24V32M18 33.6L18 34.4C18 34.9601 18 35.2401 18.109 35.454C18.2049 35.6422 18.3578 35.7952 18.546 35.891C18.7599 36 19.0399 36 19.6 36H34.4C34.9601 36 35.2401 36 35.454 35.891C35.6422 35.7952 35.7951 35.6422 35.891 35.454C36 35.2401 36 34.9601 36 34.4V33.6C36 33.04 36 32.7599 35.891 32.546C35.7951 32.3579 35.6422 32.2049 35.454 32.109C35.2401 32 34.9601 32 34.4 32H19.6C19.0399 32 18.7599 32 18.546 32.109C18.3578 32.2049 18.2049 32.3579 18.109 32.546C18 32.7599 18 33.04 18 33.6ZM26.6529 18.0772L19.2529 19.7216C18.8059 19.8209 18.5823 19.8706 18.4155 19.9908C18.2683 20.0969 18.1527 20.2409 18.0811 20.4076C18 20.5965 18 20.8255 18 21.2835L18 22.4C18 22.9601 18 23.2401 18.109 23.454C18.2049 23.6422 18.3578 23.7952 18.546 23.891C18.7599 24 19.0399 24 19.6 24H34.4C34.9601 24 35.2401 24 35.454 23.891C35.6422 23.7952 35.7951 23.6422 35.891 23.454C36 23.2401 36 22.9601 36 22.4V21.2835C36 20.8255 36 20.5965 35.9188 20.4076C35.8473 20.2409 35.7317 20.0969 35.5845 19.9908C35.4177 19.8706 35.1942 19.8209 34.7471 19.7216L27.3471 18.0772C27.2176 18.0484 27.1528 18.034 27.0874 18.0282C27.0292 18.0231 26.9708 18.0231 26.9126 18.0282C26.8472 18.034 26.7824 18.0484 26.6529 18.0772Z",
    stroke: "#0D968F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionIcon);
export default __webpack_public_path__ + "static/media/institution-icon.d4d4979d2df40ae90333f1eb60cd8ce4.svg";
export { ForwardRef as ReactComponent };